"use client";

import { c as _c } from "react/compiler-runtime";
import { createContext, useContext, useMemo } from "react";
import { useContextSelector } from "use-context-selector";
import { ArrowBackIosNew, ArrowForwardIos, ChevronLeft, ChevronRight } from "../../icons";
import { classNames } from "../../utils/classNames";
import { CenterAligned } from "../CenterAligned";
import { FlexCenter } from "../FlexCenter";
import { UnstyledButton } from "../UnstyledButton";
import { CarouselContext as MainCarouselContext } from "./CarouselProvider";
import { arrowButtonBaseVariants, arrowButtonContainerVariants, carouselArrowButtonVariants } from "./styles";
function CarouselArrowNavButton(t0) {
  const $ = _c(21);
  let children;
  let className;
  let disabled;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      children,
      disabled,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = disabled;
    $[4] = props;
  } else {
    children = $[1];
    className = $[2];
    disabled = $[3];
    props = $[4];
  }
  const {
    variant
  } = useContext(CarouselArrowsContext);
  let t1;
  if ($[5] !== className || $[6] !== disabled || $[7] !== variant) {
    t1 = classNames(arrowButtonContainerVariants({
      variant,
      disabled
    }), className);
    $[5] = className;
    $[6] = disabled;
    $[7] = variant;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== variant) {
    t2 = arrowButtonBaseVariants({
      variant
    });
    $[9] = variant;
    $[10] = t2;
  } else {
    t2 = $[10];
  }
  let t3;
  if ($[11] !== children) {
    t3 = <CenterAligned className="size-full">{children}</CenterAligned>;
    $[11] = children;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  let t4;
  if ($[13] !== disabled || $[14] !== props || $[15] !== t2 || $[16] !== t3) {
    t4 = <UnstyledButton className={t2} disabled={disabled} {...props}>{t3}</UnstyledButton>;
    $[13] = disabled;
    $[14] = props;
    $[15] = t2;
    $[16] = t3;
    $[17] = t4;
  } else {
    t4 = $[17];
  }
  let t5;
  if ($[18] !== t1 || $[19] !== t4) {
    t5 = <FlexCenter className={t1}>{t4}</FlexCenter>;
    $[18] = t1;
    $[19] = t4;
    $[20] = t5;
  } else {
    t5 = $[20];
  }
  return t5;
}
function CarouselPrevious(t0) {
  const $ = _c(14);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  const {
    variant,
    size
  } = useContext(CarouselArrowsContext);
  const [scrollPrev, canScrollPrev] = useContextSelector(MainCarouselContext, _temp);
  let t1;
  if ($[3] !== className || $[4] !== variant) {
    t1 = classNames(carouselArrowButtonVariants({
      variant,
      direction: "previous"
    }), className);
    $[3] = className;
    $[4] = variant;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const t2 = !canScrollPrev;
  let t3;
  if ($[6] !== size) {
    t3 = size === "lg" ? <ArrowBackIosNew className="translate-x-[-0.5px]" size={16} /> : <ChevronLeft size={24} />;
    $[6] = size;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== props || $[9] !== scrollPrev || $[10] !== t1 || $[11] !== t2 || $[12] !== t3) {
    t4 = <CarouselArrowNavButton aria-label="Previous" className={t1} disabled={t2} onClick={scrollPrev} {...props}>{t3}</CarouselArrowNavButton>;
    $[8] = props;
    $[9] = scrollPrev;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}
function _temp(ctx) {
  return [ctx?.scrollPrev, ctx?.canScrollPrev];
}
function CarouselNext(t0) {
  const $ = _c(14);
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = props;
  } else {
    className = $[1];
    props = $[2];
  }
  const {
    variant,
    size
  } = useContext(CarouselArrowsContext);
  const [scrollNext, canScrollNext] = useContextSelector(MainCarouselContext, _temp2);
  let t1;
  if ($[3] !== className || $[4] !== variant) {
    t1 = classNames(carouselArrowButtonVariants({
      variant,
      direction: "next"
    }), className);
    $[3] = className;
    $[4] = variant;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  const t2 = !canScrollNext;
  let t3;
  if ($[6] !== size) {
    t3 = size === "lg" ? <ArrowForwardIos className="translate-x-[1.5px]" size={16} /> : <ChevronRight size={24} />;
    $[6] = size;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== props || $[9] !== scrollNext || $[10] !== t1 || $[11] !== t2 || $[12] !== t3) {
    t4 = <CarouselArrowNavButton aria-label="Next" className={t1} disabled={t2} onClick={scrollNext} {...props}>{t3}</CarouselArrowNavButton>;
    $[8] = props;
    $[9] = scrollNext;
    $[10] = t1;
    $[11] = t2;
    $[12] = t3;
    $[13] = t4;
  } else {
    t4 = $[13];
  }
  return t4;
}
function _temp2(ctx) {
  return [ctx?.scrollNext, ctx?.canScrollNext];
}
const CarouselArrowsContext = createContext({
  variant: "default",
  size: "md"
});
function CarouselNavigationArrows(t0) {
  const $ = _c(10);
  const {
    variant: t1,
    size: t2,
    children,
    className
  } = t0;
  const variant = t1 === undefined ? "default" : t1;
  const size = t2 === undefined ? "md" : t2;
  let t3;
  let t4;
  if ($[0] !== size || $[1] !== variant) {
    t4 = {
      variant,
      size
    };
    $[0] = size;
    $[1] = variant;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  t3 = t4;
  const value = t3;
  let t5;
  if ($[3] !== children || $[4] !== className || $[5] !== variant) {
    t5 = variant === "static" ? <FlexCenter className={classNames("gap-2", className)}>{children}</FlexCenter> : children;
    $[3] = children;
    $[4] = className;
    $[5] = variant;
    $[6] = t5;
  } else {
    t5 = $[6];
  }
  let t6;
  if ($[7] !== t5 || $[8] !== value) {
    t6 = <CarouselArrowsContext.Provider value={value}>{t5}</CarouselArrowsContext.Provider>;
    $[7] = t5;
    $[8] = value;
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  return t6;
}
export { CarouselNavigationArrows };
export const CarouselNavigationArrowsPrevious = CarouselPrevious;
export const CarouselNavigationArrowsNext = CarouselNext;